import { Flex } from '@edreamsodigeo/prisma-design-system';
import React, { FC } from 'react';
import { usePrime } from 'clientState/providers/PrimeProvider';
import { LegLayout } from '@components/Results/Components/ThreeColumnsItinerary/LegLayout/LegLayout';
import { ThreeColumnsItineraryLayoutWrapperProps } from '@components/Results/Components/ThreeColumnsItinerary/types';
import { useEqualProminencePrimeDisplayMobileInResults } from 'clientState/hooks/useEqualProminencePrimeDisplayMobileInResults';

export const ThreeColumnsItineraryLayoutWrapper: FC<
  ThreeColumnsItineraryLayoutWrapperProps
> = ({
  itinerary,
  isAlternativeTopSection,
  withUKStyle,
  isAlternativeItineraryOnModal,
  isAlternativeItinerary,
  hasRetailingTechniques,
  isUnavailableItinerary,
  isSem,
  isSelectedItinerary,
  children,
}) => {
  const isEqualProminencePrimeDisplayMobileInResults =
    useEqualProminencePrimeDisplayMobileInResults();
  const { isPrimeTotalPriceOnCard } = usePrime() || {};
  const { legs, id } = itinerary;

  let extraPaddingTop;
  if (
    isEqualProminencePrimeDisplayMobileInResults &&
    itinerary.highlightedType !== 'default'
  ) {
    extraPaddingTop = 0;
  } else {
    extraPaddingTop =
      itinerary.highlightedType === 'recommended' ? '1x_small' : null;
  }

  return (
    <Flex
      flexDirection="row"
      position="relative"
      sx={{
        paddingX: isEqualProminencePrimeDisplayMobileInResults ? '8px' : null,
        paddingTop: extraPaddingTop,
        ...(isAlternativeTopSection && {
          borderBottom: withUKStyle || isPrimeTotalPriceOnCard ? 'none' : null,
          borderRadius:
            !withUKStyle && !isPrimeTotalPriceOnCard ? 'regular' : null,
          borderTopRightRadius: 'regular',
          borderTopLeftRadius: 'regular',
          margin: !withUKStyle ? '-16px' : null,
        }),
        ...(isAlternativeItineraryOnModal && {
          maxHeight: isSelectedItinerary ? '168px' : '136px',
          borderRadius: 'regular',
          borderBottom: withUKStyle && '1px solid #CBCBCB',
          backgroundColor: isSelectedItinerary ? 'neutral.20' : 'neutral.0',
        }),
      }}
    >
      <LegLayout
        withUKStyle={withUKStyle}
        isAlternativeTopSection={isAlternativeTopSection}
        isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
        isAlternativeItinerary={isAlternativeItinerary}
        legs={legs}
        hasRetailingTechniques={hasRetailingTechniques}
        itineraryId={id}
        isUnavailableItinerary={isUnavailableItinerary}
        isSem={isSem}
      />
      {children}
    </Flex>
  );
};
